import React from "react";

export const LazySystemMonitorResultPaletteInsertBridge = React.lazy(
    () =>
        import(/* webpackChunkName: "SystemMonitor" */ "./ResultPaletteInsert")
);
